<template>
  <div class="chart-container donut">
    <div v-if="!chartData">
      <b-alert variant="warning" show>No data found for the selected options</b-alert>
    </div>
    <div class="chart" :style="chartStyle">
      <canvas :id="elementId"></canvas>
    </div>
  </div>
</template>


<script>
import Chart from '@/lib/mixins/Chart'

export default {
  mixins: [Chart],
  name: 'DonutChart',
  props: ['results', 'options'],
  data () {
    return {
      chartType: 'doughnut',
      itemLinks: []
    }
  },
  computed: {
    chartJsData () {
      return {
        labels: this.chartData.labels,
        datasets: [
          {
            data: this.chartData.values,
            backgroundColor: this.colors(this.chartData.values.length)
          }
        ]
      }
    },
    maxSlices () {
      if (this.options.maxSlices != null) {
        return this.options.maxSlices
      } else {
        return 10
      }
    }
  },
  watch: {
    results: {
      immediate: true,
      handler (oldVal, newVale) {
        this.update()
      }
    },
    options: {
      immediate: true,
      handler (oldVal, newVal) {
        this.update()
      }
    },
    chartData: {
      immediate: true,
      handler (oldVal, newVal) {
        this.draw()
      }
    }
  },
  methods: {
    update () {
      if (this.results != null && this.results.rows.length > 0) {
        var labelColumn = this.results.columns[0]
        var valueColumn = this.results.columns[this.results.columns.length - 1]
        this.chartData = {
          labels: this.results.rows.map((row) => row[labelColumn.key]),
          values: this.results.rows.map((row) => row[valueColumn.key])
        }
        this.itemLinks = this.results.rows.map((row) => row.link)
      } else {
        this.chartData = null
        this.itemLinks = []
      }
    },
    clickChart (event, item) {
      if (item.length > 0) {
        const index = item[0]._index
        const link = this.itemLinks[index]
        this.selectLink(link)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/DonutChart.vue